import React from "react";
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleXmark } from "@fortawesome/pro-solid-svg-icons";
import { useTheme } from "styled-components";
import { BillPreview } from "./Services/UpfrontPaymentService";
import { GetTypographyContent } from "../shared/Typography/Typography";
import { PaidIcon } from "../../assets/iconComponents/PaidIcon";
import { PaymentPlanIcon } from "../../assets/iconComponents/PaymentPlanIcon";
import {
  PaymentStatusContainer,
  PastDueText,
  PastDueDate,
} from "./StatusDetails.styles";
import { dateFormatter } from "../../utils/helpers";

export const StatusDetails: React.FC<{
  billPreview: BillPreview;
  paymentSubmitted: boolean;
  isPastDue: boolean;
  hasFailedPayment?: boolean;
}> = ({
  billPreview,
  paymentSubmitted,
  isPastDue,
  hasFailedPayment = false,
}) => {
  const theme = useTheme();
  const { t } = useTranslation();
  const failedPaymentColor = theme.redDark;

  // Check for failed payment first - highest priority
  if (
    billPreview.portal_bill_status === "failure" ||
    (hasFailedPayment && billPreview.portal_bill_status === "in_progress")
  ) {
    return GetTypographyContent({
      content: (
        <PaymentStatusContainer>
          <div>
            <FontAwesomeIcon icon={faCircleXmark} color={failedPaymentColor} />
          </div>
          <PastDueText>{t("upfrontPayment.status.paymentFailed")}</PastDueText>
        </PaymentStatusContainer>
      ),
      size: "medium",
      textColor: "black",
    });
  }

  if (billPreview.portal_bill_status === "paid_in_full") {
    return GetTypographyContent({
      content: <PaidIcon />,
      size: "medium",
      textColor: "black",
    });
  }
  if (billPreview.portal_bill_status === "in_progress") {
    return GetTypographyContent({
      content: <PaymentPlanIcon />,
      size: "medium",
      textColor: "black",
    });
  }
  if (billPreview.portal_bill_status === "refunded") {
    return GetTypographyContent({
      content: t("upfrontPayment.status.refunded"),
      size: "medium",
      textColor: "black",
    });
  }

  if (
    billPreview.due_date &&
    billPreview.portal_bill_status === "outstanding"
  ) {
    if (isPastDue) {
      return GetTypographyContent({
        content: (
          <>
            <PastDueText>{t("upfrontPayment.status.pastDue")}</PastDueText>{" "}
            <PastDueDate>{dateFormatter(billPreview.due_date)}</PastDueDate>
          </>
        ),
        size: "medium",
        textColor: "black",
      });
    }
    return GetTypographyContent({
      content: t("upfrontPayment.status.dueOn", {
        date: dateFormatter(billPreview.due_date),
      }),
      size: "medium",
      textColor: "black",
    });
  }
  return GetTypographyContent({
    content: t("upfrontPayment.status.awaitingPayment"),
    size: "medium",
    textColor: "black",
  });
};
